import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgOpmerking = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#60D15D"
      fillRule="evenodd"
      d="m9.19 27.18-1.32 4.3 4.3-1.32a12.12 12.12 0 1 0-3-3z"
      clipRule="evenodd"
    />
    <path
      fill="#15265A"
      d="M13.93 11a11.1 11.1 0 0 1 7.9-3.3 11.27 11.27 0 0 1 0 22.53v-.86a10.4 10.4 0 1 0 0-20.8 10.2 10.2 0 0 0-7.28 3z"
    />
    <path
      fill="#fff"
      d="M20.85 12.2h-3.43l.58 9.56h2.25zm-1.72 14.73a1.67 1.67 0 0 0 1.24-.5 1.65 1.65 0 0 0 .5-1.21 1.74 1.74 0 0 0-1.74-1.75 1.67 1.67 0 0 0-1.22.51 1.7 1.7 0 0 0-.51 1.24 1.65 1.65 0 0 0 .5 1.21 1.67 1.67 0 0 0 1.23.5"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgOpmerking);

export default ForwardRef;
